export default "__VITE_ASSET__B087gGZP__"